module.exports = __webpack_public_path__ + "img/487613-2.e00659c0.png";